"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceUserType = void 0;
var PlaceUserType;
(function (PlaceUserType) {
    PlaceUserType["company"] = "COMPANY";
    PlaceUserType["employee"] = "EMPLOYEE";
})(PlaceUserType || (exports.PlaceUserType = PlaceUserType = {}));
//# sourceMappingURL=PlaceUserDto.js.map